/**
 * Team Block.
 * 
 */

/* global Alpine */

const gsap = require("gsap/dist/gsap").gsap;
const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

function initTeamGrid() {
	// console.log("TEAM: initTeamGrid()");

	let
		$teamBlockContent = $('.team-block__container'),	
		$teamGrid = $('.team-grid'),
		teamGridH = 0,
		$cap1 = $('.capsule-wrap--1'),
		$cap2 = $('.capsule-wrap--2'),
		$cap3 = $('.capsule-wrap--3'),
		hashCategory = window.location.hash.substr(1),
		$peopleLink = $('.about-us-our-people'),
		$investorLink = $('.about-us-our-investors'),
		inited = false;

	Alpine.data('teamBlockComponent', () => ({
		// Function init() randomizes members and fades them in.
		init() {
			// console.log("TEAM: init(): "+hashCategory);

			const myref = this;
			$(window).on('hashchange', function(e){
				hashCategory = window.location.hash.substr(1);
				myref.checkHash();
			});
	
			// If url has anchor tag #investors, trigger 'investors'.
			// Set filter UI to highlight 'investors'.
			if (hashCategory == 'our-investors') {
				this.setCategory('investors');
				setTeamFilter('investors');
			} else if (hashCategory == 'our-people') {
				this.setCategory('all');
				setTeamFilter('all');
			}
			this.members = this.shuffle(members);
			this.culture1 = this.shuffle(culture1);
			this.culture2 = this.shuffle(culture2);
			this.stat = this.shuffle(stat);
			this.fadeIn();
			inited = true;

			// Trigger filter clicks from ABOUT subnav links.
			const ref = this;
			$peopleLink.on('click', function() {
				// console.log("CLICKED ABOUT > OUR PEOPLE on ABOUT page");
				ref.setCategory('all');
				setTeamFilter('all');
			});
			$investorLink.on('click', function() {
				// console.log("CLICKED ABOUT > OUR INVESTORS on ABOUT page");
				ref.setCategory('investors');
				setTeamFilter('investors');
			});
		},

		checkHash() {
			if (hashCategory == 'our-investors') {
				this.setCategory('investors');
				setTeamFilter('investors');
			} else if (hashCategory == 'our-people') {
				this.setCategory('all');
				setTeamFilter('all');
			}			
		},

		// Function fadeIn() sets .team-block__container to invisible, then transitions to visible in .1s.
		fadeIn() {
			// console.log("TEAM: fadeIn()");
			// Do not hide team if it has already been initialized / loaded and rendered once.
			if (inited) {
				this.visible = false;
				this.$refs.cap1Content.style.transitionDuration = '0s';
				this.$refs.cap2Content.style.transitionDuration = '0s';
				this.$refs.cap3Content.style.transitionDuration = '0s';
				this.$refs.cap1Content.style.opacity = 0;
				this.$refs.cap2Content.style.opacity = 0;
				this.$refs.cap3Content.style.opacity = 0;
			}
			setTimeout(() => {
				this.visible = true;
				this.$refs.cap1Content.style.transitionDuration = '500ms';
				this.$refs.cap2Content.style.transitionDuration = '500ms';
				this.$refs.cap3Content.style.transitionDuration = '500ms';	
				this.$refs.cap1Content.style.opacity = 1;
				this.$refs.cap2Content.style.opacity = 1;
				this.$refs.cap3Content.style.opacity = 1;
			}, 100);
		},
	
		// .team-block__container is visible.
		visible: true,
		// .capsule-culture__content are visible.
		page: 1,
		// .team-block__container displays 8 members per page.
		count: 13,
		// .team-block__container is initially NOT filtered.
		category: 'all',
		// .team-block__container max pages is initially NOT defined.
		maxPages: null,

		filteredList: null,
	
		// Function filteredMembers()...
		filteredMembers() {
			// console.log('TEAM: filteredMembers(): '+this.category);
			// if  (this.category == 'investors') {
			if (["investors","advisors","board-of-directors"].indexOf(this.category) != -1) {
				this.setGridHeight();
				return;
			}
			// Create/populate 'filteredList'.
			// if a filter category is selected, return filtered members for that category...
			// if not, return all members.
			const filteredList = this.category 
			? this.members.filter((item) => {
				return item.category.includes(this.category);
				})
			: this.members;
			// Save filteredList in this.filteredList for use elsewhere.
			this.filteredList = filteredList;
			// 'listLength' = how many members in filteredList?
			const listLength = filteredList.length;
			// Update 'maxPages' = #members / #members per page.
			this.maxPages = Math.ceil(listLength / this.count);
			// 'start' is index of first member on current page.
			// 'end' is index of last member on current page.
			// Calculate 'start'.
			const start = ((this.page - 1) * this.count);
			// If #members > the index of last member of currently displayed(?) page...
			// (We are not on the last page of filtered members)
			// 'end' is 'start' + #members per page.
			// If not...
			// (We ARE on the last page of filtered members)
			// 'end' is the total #members.
			const end = listLength > start + this.count 
			? start + this.count
			: listLength;
			// If filter returns zero members, hide all capsules.
			if (listLength == 0) {
				// console.log('TEAM: filteredMembers(): HIDE ALL CAPS');
				$('.capsule-culture').addClass('is-hidden');
			} else {
				// console.log('TEAM: filteredMembers(): SHOW ALL CAPS');
				$('.capsule-culture').removeClass('is-hidden');
			}

			const wwidth = $(window).width();

			// If this is the last page...
			// Check number of members and hide capsules if necessary.
			if (this.page == this.maxPages) {
				// Get number of members on this page.
				const listLength = this.filteredList.length % this.count;
				// console.log("TEAM: members on last page: "+listLength);
				// Get viewport width.
				const wwidth = $(window).width();
				// console.log("TEAM: pages: "+this.page+" / "+this.maxPages);
	
				$cap1.removeClass('is-hidden');
				$cap2.removeClass('is-hidden');
				$cap3.removeClass('is-hidden');
				if (wwidth < 390) {
					if (listLength < 13) {
						$cap3.addClass('is-hidden');
					}
					if (listLength < 8) {
						$cap2.addClass('is-hidden');
					}
					if (listLength < 4) {
						$cap1.addClass('is-hidden');
					}
				} else if (wwidth < 565) {
					if (listLength < 13) {
						$cap3.addClass('is-hidden');
					}
					if (listLength < 8) {
						$cap2.addClass('is-hidden');
					}
					if (listLength < 4) {
						$cap1.addClass('is-hidden');
					}
				// } else if (wwidth < 740) {
				} else if (wwidth < 1024) {
					if (listLength < 13) {
						$cap3.addClass('is-hidden');
					}
					if (listLength < 9) {
						$cap2.addClass('is-hidden');
					}
					if (listLength < 3) {
						$cap1.addClass('is-hidden');
					}
				// } else if (wwidth < 1200) {
				} else if (wwidth < 1320) {
					if (listLength < 13) {
						$cap3.addClass('is-hidden');
					}
					if (listLength < 6) {
						$cap2.addClass('is-hidden');
					}
					if (listLength < 2) {
						$cap1.addClass('is-hidden');
					}
				} else {
					if (listLength < 13) {
						$cap3.addClass('is-hidden');
					}
					if (listLength < 9) {
						$cap2.addClass('is-hidden');
					}
					if (listLength < 3) {
						$cap1.addClass('is-hidden');
					}
				};
			} else {
				$cap1.removeClass('is-hidden');
				$cap2.removeClass('is-hidden');
				$cap3.removeClass('is-hidden');
			}

			// Function returns array of members to display on current page.
			// this.setGridHeight();
			this.setGridHeightSimple();
			return filteredList.slice(start, end);
		},

		sortedCulture1() {
			// console.log('TEAM: sortedCulture1()');
			const sortedList = this.culture1;
			const listLength = sortedList.length;
			const start = this.page > listLength ? (this.page - 1) % listLength : (this.page - 1);
			const end = start + 1;
			return sortedList.slice(start, end);
		},
		sortedCulture2() {
			// console.log('TEAM: sortedCulture2()');
			const sortedList = this.culture2;
			const listLength = sortedList.length;
			const start = this.page > listLength ? (this.page - 1) % listLength : (this.page - 1);
			const end = start + 1;
			return sortedList.slice(start, end);
			// return null;
		},
		sortedStat() {
			// console.log('TEAM: sortedStat()');
			const sortedList = this.stat;
			const listLength = sortedList.length;
			const start = this.page > listLength ? (this.page - 1) % listLength : (this.page - 1);
			const end = start + 1;
			return sortedList.slice(start, end);
			// return null;
		},

		setGridHeight() {
			// console.log('TEAM: setGridHeight()');

			this.$nextTick(() => {
				// Grab current (old height)
				const oldHeight = this.$refs.grid.style.height;
				// Calculate new height (need to disable transition)
				this.$refs.grid.style.transitionDuration = '0s';
				this.$refs.grid.style.height = null;
				const newHeight = this.$refs.grid.offsetHeight + 'px';
				// Set height to old height, to allow for CSS height transition
				this.$refs.grid.style.height = oldHeight;
				setTimeout(() => {
					// Set new height after a beat...
					this.$refs.grid.style.transitionDuration = '500ms';
					this.$refs.grid.style.height = newHeight;
					}, 10);
			});
			setTimeout(()=> {
				ScrollTrigger.refresh();
			}, 1000);
		},
		setGridHeightSimple() {
			// console.log('TEAM: setGridHeightSimple()');
			const wwidth = $(window).width();

			// 2-column .team-grid.
			if (wwidth < 565) {
				this.$refs.grid.style.height = 'auto';
				// setTimeout(() => {
				// 	// Get total height of chip rows.
				// 	var rowHeight = 0;
				// 	var gridGap = parseFloat($('.team-grid').css('row-gap'));
				// 	var chipsHeight = 0;
				// 	var chipCount = 0;
				// 	$('.team-chip__wrap').each(function() {
				// 		chipCount++;
				// 		if (chipCount%2 == 1) {
				// 			// chipsHeight += $(this).outerHeight();
				// 			rowHeight =  Math.max($(this).outerHeight(), $(this).next().outerHeight());
				// 			chipsHeight += rowHeight;
				// 			chipsHeight += gridGap;
				// 			// console.log('TEAM: setGridHeightSimple(): chip1: '+$(this).find('.team-chip__info-name').text());
				// 			// console.log('TEAM: setGridHeightSimple(): chip1: '+$(this).outerHeight());
				// 			// console.log('TEAM: setGridHeightSimple(): chip2: '+$(this).next().find('.team-chip__info-name').text());
				// 			// console.log('TEAM: setGridHeightSimple(): chip2: '+$(this).next().outerHeight());
				// 			// console.log('TEAM: setGridHeightSimple(): rowHeight: '+rowHeight);
				// 		}
				// 	});
				// 	var capHeight = 0;
				// 	var capsHeight = 0;
				// 	var capCount = 0;
				// 	$('.capsule-wrap').each(function() {
				// 		capCount++;
				// 		if (capCount < 3) {
				// 			capHeight = $(this).outerHeight();
				// 			capsHeight += capHeight;
				// 			if ($(this).outerHeight()) {
				// 				capsHeight += gridGap;
				// 				// console.log('TEAM: setGridHeightSimple(): capHeight: '+capHeight);
				// 				// console.log('TEAM: setGridHeightSimple(): capsHeight: '+capsHeight);
				// 			}
				// 		}
				// 	});
				// 	const newHeight = chipsHeight + capsHeight + 'px';
				// 	setTimeout(() => {
				// 		this.$refs.grid.style.height = newHeight;
				// 	}, 10);
				// }, 100);
			// 3-column .team-grid.
			} else if (wwidth < 1024) {
				// this.$refs.grid.style.height = 'fit-content';
				this.$refs.grid.style.height = 'auto';
				// setTimeout(() => {
				// 	// Get total height of chip rows.
				// 	var rowHeight = 0;
				// 	var gridGap = parseFloat($('.team-grid').css('row-gap'));
				// 	var chipsHeight = 0;
				// 	var chipCount = 0;
				// 	$('.team-chip__wrap').each(function() {
				// 		chipCount++;
				// 		if (chipCount%3 == 1) {
				// 			// chipsHeight += $(this).outerHeight();
				// 			rowHeight = Math.max($(this).outerHeight(), $(this).next().outerHeight(), $(this).next().next().outerHeight());
				// 			chipsHeight += rowHeight;
				// 			chipsHeight += gridGap;
				// 		}
				// 	});
				// 	var capsHeight = 0;
				// 	var capCount = 0;
				// 	$('.capsule-wrap').each(function() {
				// 		capCount++;
				// 		if (capCount < 3) {
				// 			capsHeight += $(this).outerHeight();
				// 			if ($(this).outerHeight()) {
				// 				capsHeight += gridGap;
				// 				// console.log('TEAM: setGridHeightSimple(): capHeight: '+capHeight);
				// 				// console.log('TEAM: setGridHeightSimple(): capsHeight: '+capsHeight);
				// 			}
				// 		}
				// 	});
				// 	const newHeight = chipsHeight + capsHeight + 'px';
				// 	// if (this.page == this.maxPages) {
				// 	// 	this.$refs.grid.style.height = 'fit-content';
				// 	// } else {
				// 	setTimeout(() => {
				// 		this.$refs.grid.style.height = newHeight;
				// 	}, 10);
				// 	// }
				// }, 100);
			} else {
				this.setGridHeight();
			}
			setTimeout(()=> {
				ScrollTrigger.refresh();
			}, 300);
		},
		
		// Function setCategory()...
		setCategory(categorySelection) {
			// console.log('TEAM: setCategory(): '+categorySelection);
			// A filter has been selected. Update filter category.
			// Display page 1 of newly filtered members.

			// If displaying Investors, set height of empty Team grid to height of Investors page.
			if (categorySelection == 'investors') {

				$('.page-nav').fadeOut(0);
				$cap1.addClass('is-hidden');
				$cap2.addClass('is-hidden');
				$cap3.addClass('is-hidden');
				$('.investors__page').fadeIn(500);
				$('.advisors__page').fadeOut(0);
				// Set .team-grid height to .investors__page height.
				this.$refs.grid.style.height = this.$refs.investors.style.height + 'px';
				// console.log("TEAM: $cap1.addClass('is-hidden');");

			// If displaying Board of Directors, set height of empty Team grid to height of Directors page.
			} else if (categorySelection == 'board-of-directors') {

				$('.page-nav').fadeOut(0);
				$cap1.addClass('is-hidden');
				$cap2.addClass('is-hidden');
				$cap3.addClass('is-hidden');
				$('.advisors__page.directors').fadeIn(500);
				$('.investors__page').fadeOut(0);
				$('.advisors__page.advisors').fadeOut(0);
				// Set .team-grid height to .advisors__page height.
				this.$refs.grid.style.height = this.$refs.boardOfDirectors.style.height + 'px';
				// console.log("TEAM: $cap1.addClass('is-hidden');");

			// If displaying Advisors, set height of empty Team grid to height of Advisors page.
			} else if (categorySelection == 'advisors') {

				$('.page-nav').fadeOut(0);
				$cap1.addClass('is-hidden');
				$cap2.addClass('is-hidden');
				$cap3.addClass('is-hidden');
				$('.advisors__page.advisors').fadeIn(500);
				$('.investors__page').fadeOut(0);
				$('.advisors__page.directors').fadeOut(0);
				// Set .team-grid height to .advisors__page height.
				this.$refs.grid.style.height = this.$refs.advisors.style.height + 'px';
				// console.log("TEAM: $cap1.addClass('is-hidden');");

			} else {
				$('.page-nav').fadeIn();
				$cap1.removeClass('is-hidden');
				$cap2.removeClass('is-hidden');
				$cap3.removeClass('is-hidden');
				$('.investors__page').fadeOut(0);
				$('.advisors__page').fadeOut(0);
				// console.log("TEAM: $cap1.removeClass('is-hidden');");
			}
			this.category = categorySelection;
			this.page = 1;
			this.fadeIn();
		},

		prev() {
			if (this.page > 1) {
				this.page--;
				this.fadeIn();
				setTimeout(()=> {
					ScrollTrigger.refresh();
				}, 300);
			}
		},
	
		next() {
			if (this.page < this.maxPages) {
				this.page++;
				this.fadeIn();
				setTimeout(()=> {
					ScrollTrigger.refresh();
				}, 300);
			}
		},
	
		shuffle(array) { 
			for (let i = array.length - 1; i > 0; i--) { 
			const j = Math.floor(Math.random() * (i + 1)); 
			[array[i], array[j]] = [array[j], array[i]]; 
			} 
			return array; 
		}
	}));
}

/**
 * Team Filter UI.
 * Mobile: Dropdown/expand-collapse filter panel.
 * Desktop: Button filter nav.
 */

function initMobileFilter() {
	// console.log("TEAM: initMobileFilter()");

	let
		$excolBtn = $('.team-block__filter-selected'),
		$selectedFilterMobile = $('.team-block__filter-term-selected'),
		$filterPanelMobile = $('.filter__panel-container'),
		$filterBtnsMobile = $('.filter__panel-link'),
		$filterBtnsDesktop = $('.team-block__filter-term'),
		$myBtn,
		$myBtnDesktop;

	$excolBtn.on('click', function() {
		// console.log("TEAM: initMobileFilter(): CLICK");
		if (!$(this).hasClass('is-active')) {
			// Expand filter panel.
			// $filterPanel.fadeIn(300);
			$(this).addClass('is-active');
			$filterPanelMobile.addClass('is-active');
		} else {
			// $filterPanel.fadeOut(300);
			$(this).removeClass('is-active');
			$filterPanelMobile.removeClass('is-active');
		}
	});

	$filterBtnsMobile.on('click', function(event) {
		event.preventDefault();
		$myBtn = $(this);
		if (!$myBtn.hasClass('active')) {
			// Make button active.
			$filterBtnsMobile.removeClass('active');
			$filterBtnsDesktop.removeClass('active');
			$myBtn.addClass('active');
			$filterBtnsDesktop.removeClass('active');
			$myBtnDesktop = $filterBtnsDesktop.filter('[data-filter=' + $(this).data('filter') + ']');
			$myBtnDesktop.addClass('active');
			$excolBtn.removeClass('is-active');
			$filterPanelMobile.removeClass('is-active');
			$selectedFilterMobile.html($myBtn.html());
		}
	});
}

function setTeamFilter(myFilter) {
	let
		$excolBtn = $('.team-block__filter-selected'),
		$selectedFilterMobile = $('.team-block__filter-term-selected'),
		$filterPanelMobile = $('.filter__panel-container'),
		$filterBtnsMobile = $('.filter__panel-link'),
		$filterBtnsDesktop = $('.team-block__filter-term'),
		$myBtnDesktop = $filterBtnsDesktop.filter('[data-filter=' + myFilter + ']'),
		$myBtnMobile = $filterBtnsMobile.filter('[data-filter=' + myFilter + ']');

	// Deactivate all buttons.
	$filterBtnsMobile.removeClass('active');
	$filterBtnsDesktop.removeClass('active');
	// Activate desktop filter button.
	$myBtnDesktop.addClass('active');
	// Activate mobile filter button.
	$myBtnMobile.addClass('active');
	$excolBtn.removeClass('is-active');
	$filterPanelMobile.removeClass('is-active');
	$selectedFilterMobile.html($myBtnDesktop.html());
}

function initDesktopFilter() {
	// console.log("TEAM: initDesktopFilter()");

	let
		$selectedFilterMobile = $('.team-block__filter-term-selected'),
		$filterBtnsMobile = $('.filter__panel-link'),
		$filterBtnsDesktop = $('.team-block__filter-term'),
		$myBtn,
		$myButtonMobile;

	$filterBtnsDesktop.on('click', function() {
		$myBtn = $(this);
		if (!$myBtn.hasClass('active')) {
			// Make button active.
			$filterBtnsDesktop.removeClass('active');
			$myBtn.addClass('active');
			$filterBtnsMobile.removeClass('active');
			$myButtonMobile = $filterBtnsMobile.filter('[data-filter=' + $(this).data('filter') + ']');
			$myButtonMobile.addClass('active');
			$selectedFilterMobile.html($myBtn.html());
		}
	});
}

exports.init = function () {
	// console.log('TEAM: exports.init');
	// Run init methods...

	initMobileFilter();
	initDesktopFilter();
	document.addEventListener('alpine:init', () => {
		initTeamGrid();
	});
};